// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/project/:projectId\",\"regex\":\"^/project/([^/]+)$\",\"paramNames\":[\"projectId\"],\"hasOptionalPrefix\":false},{\"path\":\"/project/:projectId/edit\",\"regex\":\"^/project/([^/]+)/edit$\",\"paramNames\":[\"projectId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/ai-diagnostic\"},{\"path\":\"/assessment\"},{\"path\":\"/evidence\"},{\"path\":\"/issue\"},{\"path\":\"/organizations\"},{\"path\":\"/profile-settings\"},{\"path\":\"/profile-settings/manage-notifications\"},{\"path\":\"/profile-settings/password-security\"},{\"path\":\"/project\"},{\"path\":\"/project/new\"},{\"path\":\"/report\"},{\"path\":\"/report-project\"},{\"path\":\"/standards\"},{\"path\":\"/standards/edit\"},{\"path\":\"/standards/new\"},{\"path\":\"/users\"},{\"path\":\"/login\"},{\"path\":\"/reset-password\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";import * as Sentry from "@sentry/nextjs";

import { getSentryEnvironment, SENTRY_DATA_COLLECTION } from "@/lib/sentryConfig";

Sentry.init({
  dsn: "https://3c748acbee7ea7d3882703b7affac22f@o4511792000663552.ingest.us.sentry.io/4511792005054464",
  environment: getSentryEnvironment(),

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  dataCollection: SENTRY_DATA_COLLECTION,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
